import { inject, Injectable } from '@angular/core';
import { Counterparty } from '@core/types';
import { UpdateUserPayload, User, UserSettings } from '@core/types/User';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';

const { apiUrl, api2Url } = environment;

@Injectable({
  providedIn: 'root',
})
export class AccountAPIService {
  private readonly http = inject(HttpClient);

  getCurrentUser$(): Observable<User | null> {
    return this.http.get<User | null>(`${api2Url}/users/getSelf`);
  }

  updateCurrentUser$(updatedUserFields: UpdateUserPayload): Observable<{
    done: true;
  }> {
    return this.http.post<{
      done: true;
    }>(`${apiUrl}/myProfile`, updatedUserFields, {
      responseType: 'text' as any,
    });
  }

  getUserSettings$() {
    return this.http.get<UserSettings | null>(`${api2Url}/users/userSettings`);
  }

  createOrUpdateUserSettings$(settings: Partial<UserSettings>) {
    return this.http.post<void>(`${api2Url}/users/userSettings`, {
      settings,
    });
  }

  resetUserSettings$(keys?: (keyof UserSettings)[]) {
    return this.http.delete<void>(`${api2Url}/users/userSettings/delete`, {
      body: { keys: keys },
    });
  }

  getCurrentUserCounterparties$(): Observable<Counterparty[]> {
    return this.http.get<Counterparty[]>(`${api2Url}/users/me/counterparties`);
  }
}
